import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';

// Mapea el tipo de recurso de una ruta al `resourceType` del catálogo de /resources.
const RESOURCE_ROUTE_BY_TYPE = {
  images: 'laminaria',
  videos: 'videos',
  anatomical_structures: 'anatomical-collections',
};

// Config de los tres tipos de recurso que componen una ruta: label, ícono y
// estilos. La comparten la vista de detalle y el formulario para que las dos
// pantallas hablen el mismo idioma visual (mismo color por tipo de recurso).
// La key es la misma que usa el backend en el payload y en `stats`.
const RESOURCE_TYPES = [
  {
    key: 'images',
    label: 'Imágenes',
    Icon: ImageOutlinedIcon,
    header: 'text-blue-700',
    tile: 'bg-blue-100 text-blue-700',
    card: 'bg-blue-50/60 border-blue-100',
    badge: 'bg-blue-100 text-blue-700',
  },
  {
    key: 'videos',
    label: 'Videos',
    Icon: PlayCircleOutlineIcon,
    header: 'text-green-700',
    tile: 'bg-green-100 text-green-700',
    card: 'bg-green-50/60 border-green-100',
    badge: 'bg-green-100 text-green-700',
  },
  {
    key: 'anatomical_structures',
    label: 'Estructuras Anatómicas',
    Icon: ScienceOutlinedIcon,
    header: 'text-purple-700',
    tile: 'bg-purple-100 text-purple-700',
    card: 'bg-purple-50/60 border-purple-100',
    badge: 'bg-purple-100 text-purple-700',
  },
];

export { RESOURCE_ROUTE_BY_TYPE, RESOURCE_TYPES };
